import Typeahead from '@components/typeahead/geoLocationtypeahead';
import { EMPTY } from 'rxjs';
import { locationIconSvg } from 'constants/svg-assets.js';

import redirectToCurrentLocation from '../../components/currentLocationHandler';
import redirectToSearchCommunityResults from '../../components/redirectHandler';

const config = {
  searchInput: document.getElementById('blog_typeahead_input'),
  suggestionsContainer: document.getElementById('blog_typeahead_suggestions'),
  errorContainer: document.getElementById('blog_typeahead_error'),
  clearButton: document.querySelector('[data-typeahead-clear]'),
  currentLocation: {
    searchText: "Current Location",
    isEnabled: true,
    icon: locationIconSvg,
  }
};

/**
 * Typeahead observable to handle the search box component
 */
const hasLegacyTypeaheadElements =
  config.searchInput &&
  config.suggestionsContainer &&
  config.errorContainer &&
  config.clearButton;

const typeahead$ = hasLegacyTypeaheadElements ? Typeahead(config) : EMPTY;

typeahead$.subscribe((suggestion) => {

  if (suggestion.matches('[data-current-location-search]')) {
    return redirectToCurrentLocation();
  }

  return redirectToSearchCommunityResults(suggestion.dataset.value);
});

export default typeahead$;
